import React, { Component } from 'react';
import Chart from 'chart.js';
import { Tooltip } from 'antd';
import Skeleton from 'react-loading-skeleton';

class DoughnutGraph extends Component {
  componentDidUpdate() {
    this.drawGraph()
  }
  componentDidMount() {
    this.drawGraph()
  }
  drawGraph() {
    if (this.props.loading) return;

    let { graphData } = this.props;
    Chart.Tooltip.positioners.cursor = function (chartElements, coordinates) {
      //used to style coordinates(position) of tooltip
      if (coordinates.y <= 100 && coordinates.y > 75) coordinates.y = 75;
      else if (coordinates.y > 100 && coordinates.y < 140) coordinates.y = 140;
      return coordinates;
    };
    var ctx = document.getElementById(this.props.id).getContext('2d');
    new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: graphData.map((item) => item.text),
        datasets: [
          {
            label: 'Health Check Distribution',
            data: graphData.map((item) => item.percentage),
            backgroundColor: graphData.map((item) => item.color),
            borderWidth: 0,
          },
        ],
      },
      options: {
        tooltips: {
          mode: 'label',
          position: 'cursor',
        },
        elements: {
          arc: {
            borderWidth: 0,
          },
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
        responsive: true,
        legend: {
          display: false,
          position: 'top',
        },
        title: {
          display: false,
          text: 'Health Check Distribution',
        },
        cutoutPercentage: 70,
      },
    });
  }

  getTotalCount() {
    const { graphData } = this.props;
    if(this.props.title === 'Employees affected') return graphData[2].percentage + "%"
    else if (this.props.title === 'Fully vaccinated') return graphData[2].percentage +"%"
    var count = 0;
    graphData.forEach((item) => {
      count += item.number;
    });
    return count;
  }

  render() {
    if (this.props.loading) {
      return <Skeleton width='100%' height={this.props.loaderHeight} />;
    }

    let { graphData, title } = this.props;

    return (
      <div className={`flex flex-row bg-white border rounded-lg p-6 pr-0 ` + this.props.classes}>
        <div className='flex flex-col items-center justify-center'>
          <div className='text-2xl font-extrabold -mt-5 text-gray-700 absolute'>{this.getTotalCount()}</div>
          <div className='text-sm text-gray-500 mt-7 absolute align-center'>{title}</div>
          <div className='myChartDiv'>
            <canvas id={this.props.id} width='250' height='250'></canvas>
          </div>
        </div>
        <div className={`grid justify-between items-center mx-auto ` + (graphData.length > 5 ? 'grid-cols-2 ' : '')}>
          {graphData.map((item, index) => {
            return (
              <div className={`flex flex-row ` + (index % 2 === 0 && graphData.length > 5 ? 'mr-5' : ' ')} key={`${item}`+ index}>
                <Tooltip placement={this.props.tooltip_placement} title={item.tooltip}>
                  <div className='h-4 w-4 rounded-sm' style={{ backgroundColor: item.color }}></div>
                </Tooltip>
                <div className='flex flex-col ml-4'>
                  <div className='text-base font-semibold text-gray-700 leading-none mb-1'>
                    {' '}
                    {item.number} ({item.percentage}%)
                  </div>
                  <div className='text-md text-gray-500'> {item.text}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

DoughnutGraph.defaultProps = {
  classes: '',
};

export default DoughnutGraph;
